import { format, parseISO, isValid } from 'date-fns';

/**
 * Safely formats a date string using date-fns.
 * Returns a fallback string if the date is invalid.
 */
export const safeFormat = (dateStr: string | undefined | null, formatStr: string, fallback = 'Fecha inválida'): string => {
  if (!dateStr) return fallback;
  try {
    const date = parseISO(dateStr);
    if (!isValid(date)) return fallback;
    return format(date, formatStr);
  } catch (e) {
    return fallback;
  }
};
